export default "__VITE_ASSET__CtinzmeV__"